import React from 'react';
import ReactDatatable from '@ashvin27/react-datatable';
import axios from 'axios';
import { Card, CardBody, Col } from 'reactstrap';
import { baseURL } from '../../_helpers';
import * as moment from 'moment';
import DateTimeRangeContainer from 'react-advanced-datetimerange-picker'
import { FormControl } from 'react-bootstrap'
import { TOKEN } from '../../_helpers/token';
import Select from "react-select";

export class SecureDAnalysis extends React.Component {
    constructor(props) {
        super(props);
        this.applyCallback = this.applyCallback.bind(this);
        this.columns = [
            {
                key: "date",
                TrOnlyClassName: 'tsc',
                text: "Date",
                className: "tsc",
                align: "left"
            },
            {
                key: "Subscription",
                TrOnlyClassName: 'tsc',
                text: "Subscription",
                className: "tsc",
                align: "left"
            },
            {
                key: "Renewal",
                TrOnlyClassName: 'tsc',
                text: "Renewal",
                className: "tsc",
                align: "left"
            },
            {
                key: "Unsubscribe",
                TrOnlyClassName: 'tsc',
                text: "Unsubscription",
                className: "tsc",
                align: "left"
            },
            {
                key: "Net",
                TrOnlyClassName: 'tsc',
                text: "Net",
                className: "tsc",
                align: "left"
            }
        ];
        this.config = {
            key_column: "tsc",
            length_menu: [10, 20, 50],
            show_filter: false,
            show_pagination: false,
            pagination: 'advance',
            page_size: 100,
            show_length_menu: false,
            language: {
                loading_text: "Please be patient while data loads...",
                no_data_text: "No data was found",
                filter: "Enter date (YYYY-MM-DD)",
                pagination: {
                    next: <span>&#9658;</span>,
                    previous: <span>&#9668;</span>
                    // next
                    // previous
                }
            },
            button: {
                excel: true,
                print: false,
                csv: true
            }
        }
        this.state = {
            admins: [],
            isLoading: true,
            showModal: false,
            showError: false,
            isShowError: false,
            showComponent: false,
            hideComponent: false,
            data: [],
        };
        let now = new Date();
        let start = moment.utc(new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0));
        let end = moment.utc(start).add(1, "days").subtract(1, "seconds");
        this.state = {
            start: start,
            end: end,
            isPageLoad: true,
            channel: '23401220000030392',
            terms_channel: [
                {
                    label: 'LUCKYBOX 1000',
                    value: '23401220000030403',
                },
                {
                    label: 'LUCKYBOX 500',
                    value: "23401220000030397"
                },
                {
                    label: 'LUCKYBOX 100',
                    value: '23401220000030393',
                },
                {
                    label: 'LUCKYBOX 50',
                    value: "23401220000030392"
                }
            ],
            terms_channel_two: [
                {
                    label: 'LUCKYBOX `100',
                    value: '23401220000030393',
                },
                {
                    label: 'LUCKYBOX 50',
                    value: "23401220000030392"
                }
            ]


        }
    }
    componentDidMount() {
        this.setState({
            startDate: moment.utc(new Date()).format('DD MMM, YYYY'),
            endDate: moment.utc(new Date()).format('DD MMM, YYYY'),
            isPageLoad: true,
            valuedate: "Today"
        })

        this.getData(23401220000030392, moment.utc(new Date()).subtract(2, 'hours').format('YYYY-MM-DD'), moment.utc(new Date()).subtract(2, 'hours').format('YYYY-MM-DD'))

        // this.getData("", moment.utc(new Date()).subtract(2, 'hours').format('YYYY-MM-DD'), moment.utc(new Date()).subtract(2, 'hours').format('YYYY-MM-DD'))
    }

    getData = (queryString, startDate, endDate) => {

        let url = baseURL + `secure_d_analysis?channel=${queryString}&startDate="${startDate}"&endDate="${endDate}"&`;

        // alert(url)

        this.setState({
            isLoading: true,
            queryString: queryString
        })

        const config = {
            headers: {
                'Authorization': TOKEN
            }
        };
        axios.all([
            axios.get(url, config)
        ]).then(axios.spread((branchResponse) => {
            this.setState({
                admins: branchResponse.data,
                isLoading: false,
            },
                function () {
                    var data = [];

                    if (this.state.admins.length > 0) {

                        // alert(JSON.stringify(this.state.admins))

                        for (let i = 0; i < this.state.admins.length; i++) {
                            let mail;

                            data.push(Object.assign(this.state.admins[i]));
                            this.setState({
                                data: data
                            })
                        }
                    } else {
                        this.setState({
                            data: data,
                            isLoading: false,

                        })
                    }
                }
            );
        }))
    }


    applyCallback(startDate, endDate) {

        localStorage.setItem("STARTDATE", startDate)
        localStorage.setItem("ENDDATE", endDate)
        let Sdate1 = moment.utc(startDate).format('DD MMM, YYYY');
        let Edate2 = moment.utc(endDate).format('DD MMM, YYYY');
        this.setState({
            valuedate: Sdate1 + " " + Edate2,
            startDate: Sdate1,
            isPageLoad: true,
            endDate: Edate2
        })

        this.getData(this.state.queryString, moment.utc(startDate).subtract(2, 'hours').format('YYYY-MM-DD'), moment.utc(endDate).subtract(2, 'hours').format('YYYY-MM-DD'));
    }

    tableChangeHandler = data => {
        let queryString = Object.keys(data).map((key) => {
            if (key === "sort_order" && data[key]) {
                return encodeURIComponent("sort_order") + '=' + encodeURIComponent(data[key].order) + '&' + encodeURIComponent("sort_column") + '=' + encodeURIComponent(data[key].column)
            } else {
                return encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
            }

        }).join('&');

        this.getData(this.state.queryString, moment.utc(localStorage.getItem("STARTDATE")).format('YYYY-MM-DD'), moment.utc(localStorage.getItem("ENDDATE")).format('YYYY-MM-DD'))


    }

    getDataUpdate() {
        let queryString = ("filter_value=&page_number=0&page_size=10&sort_order=false")


        this.getData(23401220000030392, moment.utc(new Date()).subtract(2, 'hours').format('YYYY-MM-DD'), moment.utc(new Date()).subtract(2, 'hours').format('YYYY-MM-DD'))
    }

    handleChangeChannel = value => {
        if (value != null) {
            this.setState(
                {
                    channel: value.value,


                });

            this.getData(value.value, moment.utc(this.state.startDate).subtract(2, 'hours').format('YYYY-MM-DD'), moment.utc(this.state.endDate).subtract(2, 'hours').format('YYYY-MM-DD'));


        }

        else {
            this.setState(
                {
                    channel: "23401220000030392",
                });

        }
    }
    render() {
        let ranges = {
            "Today Only": [moment.utc(this.state.start), moment.utc(this.state.end)],
            "Yesterday Only": [
                moment.utc(this.state.start).subtract(1, "days"),
                moment.utc(this.state.end).subtract(1, "days")
            ],
            "3 Days": [moment.utc(this.state.start).subtract(3, "days"), moment.utc(this.state.end)],
            "5 Days": [moment.utc(this.state.start).subtract(5, "days"), moment.utc(this.state.end)],
            "1 Week": [moment.utc(this.state.start).subtract(7, "days"), moment.utc(this.state.end)],
            "2 Weeks": [moment.utc(this.state.start).subtract(14, "days"), moment.utc(this.state.end)],
            "1 Month": [moment.utc(this.state.start).subtract(1, "months"), moment.utc(this.state.end)],
            "1 Year": [moment.utc(this.state.start).subtract(1, "years"), moment.utc(this.state.end)]
        };
        let local = {
            "format": "DD-MM-YYYY",
            "sundayFirst": false
        }


        return (
            <div >
                < >
                    < Card >
                        <CardBody >
                            <h4><b>Secure D subscription Analysis</b></h4>
                            <br />
                            <div className="col-md-4">

                                <Select
                                    isClearable
                                    options={this.state.terms_channel}
                                    // onInputChange={this.loadOptions}
                                    placeholder="Select Product (Default Luckybox 50)"
                                    autosize={true}
                                    onChange={this.handleChangeChannel}
                                    // isLoading={this.state.isLoading}
                                    // noOptionsMessage={() => 'nothing found'}
                                    // loadingMessage={() => 'searching...'}   //minor type-O here
                                    className="selected"
                                    menuPortalTarget={document.body}
                                    name="namffe"
                                /><br />
                            </div>
                            <br />
                            <div className="row">
                                <div className="col-md-8">
                                    <div className="col-md-8">
                                        <div className="row">
                                            <div className="col-6">
                                                <DateTimeRangeContainer
                                                    ranges={ranges}
                                                    start={this.state.start}
                                                    end={this.state.end}
                                                    local={local}
                                                    applyCallback={this.applyCallback}>
                                                    <FormControl
                                                        id="formControlsTextB"
                                                        type="text"
                                                        value={this.state.valuedate}
                                                        label="Text"
                                                        placeholder="Filter by Date"
                                                    />
                                                </DateTimeRangeContainer>
                                            </div>
                                            <div className="col-6 float-left">

                                                <button className=" float-left btn btn-primary btn-sm" onClick={e => {
                                                    this.getDataUpdate();
                                                    this.setState({
                                                        startDate: moment.utc(new Date()).format('DD MMM, YYYY'),
                                                        endDate: moment.utc(new Date()).format('DD MMM, YYYY'),
                                                        valuedate: "Today"
                                                    })
                                                }} >Clear</button>
                                                {/* <input id="input" type="text" readOnly /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                </div>
                            </div><br />


                            <div className="panel-body" >
                                <div >
                                </div>
                                <br />

                                <ReactDatatable
                                    config={this.config}
                                    records={this.state.data}
                                    columns={this.columns}
                                    dynamic={true}
                                    id="tsc"
                                    loading={this.state.isLoading}
                                    total_record={this.state.mdata}
                                    onChange={this.tableChangeHandler} />
                            </div>
                        </CardBody>

                    </Card>
                </>
            </div>

        )
    }
}